import { EventTypes } from '~analytics/types';

import IntercomService from '../../intercom/IntercomService';

const sendTeacherIntercomEvent = (eventType: EventTypes) => {
  try {
    IntercomService.event(eventType);
  } catch (err) {
    console.error('Failed to send Intercom event', err);
  }
};

export { sendTeacherIntercomEvent };
